import { Button, Avatar } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleMinus, PurplePlus } from 'Images';

interface IRevealFiltersButton {
  isExpanded?: boolean;
  onClick?: () => void;
  onExpand?: () => void;
  onCollapse?: () => void;
}
export const RevealFiltersButton = ({
  isExpanded,
  onExpand,
  onCollapse,
  onClick,
}: IRevealFiltersButton) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);
  const isDesktop = useIsDesktop();

  return (
    <Button
      onClick={onClick}
      role={'switch'}
      aria-checked={isExpanded}
      aria-expanded={isExpanded}
      aria-label={isExpanded ? dictionary.shrink : dictionary.expand}
      disableTouchRipple
      sx={{
        minWidth: '0',
        width: '48px',
        height: isDesktop ? '38px' : '32px',
        border: '1px solid',
        borderColor: 'purple2.main',
        borderRadius: '48px',
        padding: '4px 12px',
        background: '#fff',
        '&:hover': {
          background: '#fff',
        },
      }}
    >
      <Avatar
        src={isExpanded ? PurpleMinus : PurplePlus}
        alt={isExpanded ? dictionary.shrink : dictionary.expand}
        sx={{
          width: isExpanded ? '24px' : '20px',
          height: isExpanded ? '24px' : '20px',
        }}
        tabIndex={0}
      />
    </Button>
  );
};
